import { imgProxy } from "@/lib/img";
import { Sparkles, ExternalLink, MessageSquare, Phone } from "lucide-react";
import FavoriteButton from "@/components/dashboard/FavoriteButton";
import WhatsAppButton from "@/components/dashboard/WhatsAppButton";

export const PLACEHOLDER =
  "https://images.unsplash.com/photo-1581197326868-51cafbd1a169?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzaWxob3VldHRlJTIwZWxlZ2FudCUyMHBvcnRyYWl0JTIwc3R1ZGlvfGVufDB8fHx8MTc4MTYzMDAzNnww&ixlib=rb-4.1.0&q=85";

export const fmtPhone = (p) => (p ? p.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3") : null);
export const scoreColor = (s) => (s >= 80 ? "#10b981" : s >= 50 ? "#c8aa6e" : "#71717a");

// A single AI-ranked profile result card. Presentational — receives the profile
// plus callbacks for opening the detail dialog and the notes dialog.
export default function AIResultCard({ p, i, onDetail, onNotes }) {
  const color = p.source_color || "#c8aa6e";
  return (
    <div data-testid={`ai-result-${i}`} className="bg-[#18181b] border border-[#27272a] hover:border-[#c8aa6e]/50 transition-colors flex flex-col overflow-hidden group" style={{ borderLeft: `3px solid ${color}` }}>
      <div className="h-1 w-full" style={{ background: color }} data-testid={`ai-colorbar-${i}`} />
      <button type="button" onClick={() => onDetail(p.id)} className="relative block aspect-[4/5] overflow-hidden bg-[#09090b]" data-testid={`ai-card-photo-${i}`}>
        <img src={imgProxy(p.photo_url, 480) || PLACEHOLDER} alt="" onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
          className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-500" />
        <span className="absolute top-2 left-2 font-head text-sm text-black bg-[#c8aa6e] px-2 py-0.5">#{i + 1}</span>
        <span className="absolute top-2 right-2 text-xs px-2 py-0.5 bg-black/70 backdrop-blur border" style={{ borderColor: scoreColor(p.score) + "88", color: scoreColor(p.score) }}>
          {p.score}%
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/90 to-transparent">
          <div className="font-head text-base text-[#fafafa] truncate">{p.name || "—"}</div>
          <div className="text-[11px] text-[#d4d4d8] inline-flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full inline-block" style={{ background: color }} />
            {p.source_name} · {p.city || "—"}
          </div>
        </div>
      </button>
      <div className="p-3 flex-1 flex flex-col gap-2">
        {p.reason && (
          <p className="text-xs text-[#c8aa6e] flex items-start gap-1.5 leading-snug">
            <Sparkles className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {p.reason}
          </p>
        )}
        <p className="text-xs text-[#a1a1aa] line-clamp-2">{p.description}</p>
        <div className="mt-auto flex items-center justify-between gap-2 pt-1 flex-wrap">
          {p.phone ? (
            <span className="text-xs font-mono text-[#fafafa] inline-flex items-center gap-1"><Phone className="w-3 h-3 text-[#71717a]" /> {fmtPhone(p.phone)}</span>
          ) : <span className="text-xs text-[#71717a]">sem número</span>}
          <div className="flex items-center gap-2.5">
            {p.phone && <WhatsAppButton phone={p.phone} name={p.name} size={14} />}
            <button onClick={() => onNotes(p)} className="text-[#a1a1aa] hover:text-[#c8aa6e]" title="Notas"><MessageSquare className="w-3.5 h-3.5" /></button>
            <FavoriteButton profileId={p.id} initial={p.is_favorite} size={14} />
            <a href={p.profile_url} target="_blank" rel="noreferrer" className="text-[#c8aa6e] hover:text-[#d4b982]" title="Ver anúncio" data-testid={`ai-card-open-${i}`}><ExternalLink className="w-3.5 h-3.5" /></a>
          </div>
        </div>
      </div>
    </div>
  );
}
